export const HALLUCINATION_SENTINEL = '[CLOUDCIX_HALLUCINATION_DETECTED]';

export function createAnswerStreamSanitizer(sentinel = HALLUCINATION_SENTINEL) {
  const bufferLength = sentinel ? sentinel.length : 0;
  let buffer = '';

  return {
    push(decodedText = '') {
      if (!decodedText) {
        return { text: '', reset: false };
      }

      if (!sentinel) {
        return { text: decodedText, reset: false };
      }

      buffer += decodedText;
      if (buffer.length <= bufferLength) {
        return { text: '', reset: false };
      }

      const visibleText = buffer.slice(0, buffer.length - bufferLength);
      buffer = buffer.slice(-bufferLength);
      return { text: visibleText, reset: false };
    },
    flush() {
      if (!buffer) {
        return { text: '', reset: false };
      }

      let output = buffer;
      let containsSentinel = false;
      if (sentinel && output.includes(sentinel)) {
        containsSentinel = true;
        output = output.split(sentinel).join('');
      }
      buffer = '';
      return { text: output, reset: containsSentinel };
    },
  };
}
